import { ContractIcon, DocumentsIcon, HandshakeIcon, HomeIcon, MandateIcon, UserIcon } from "components/icons/Icons"
import { TitleIconKey } from "enums/titleIconKey"
import { ClipboardCheck } from "lucide-react"
import { useMemo } from "react"

const componentMap = {
  [TitleIconKey.User]: UserIcon,
  [TitleIconKey.Documents]: DocumentsIcon,
  [TitleIconKey.Contract]: ContractIcon,
  [TitleIconKey.Handshake]: HandshakeIcon,
  [TitleIconKey.Home]: HomeIcon,
  [TitleIconKey.Mandate]: MandateIcon,
  [TitleIconKey.Validation]: ClipboardCheck,
}
export const TitleIconFactory: React.FC<{ titleIconKey: TitleIconKey, className?: string, addClassName?:string }> = ({ 
  titleIconKey, 
  className = "text-primary w-5 h-5",
  addClassName 
}) => {
  const Component = useMemo(() => componentMap[titleIconKey], [titleIconKey])
  if (!Component) {
    return <></>
  }
  return <div className='flex-none w-8 h-8 rounded-full flex justify-center items-center bg-primary/10 '>
    <Component className={`${className} ${addClassName}`} />
  </div>
}
